import { useEffect, useState } from "react";
import Entrada from "../page/Entrada";
import Header from "../components/body/Header";
import Footer from "../components/body/Footer";
import apiAntesala from "../../config/ConfigPublic";
import { useLocation, useParams } from "react-router-dom";
import { TotalEntradaUtils } from "../utils/TotalEntradaUtils";
import { useDispatch, useSelector } from "react-redux";
import { meState } from "../../web/models/users/Index";
import RestPrivateAntesala from "../../helpers/RestPrivateApi";
import Alerts from "../../web/components/Alerts/Alerts";
import Completado from "../page/Completado";

const EntradaController = () => {
  const dispatch = useDispatch();
  const _me = useSelector(meState);
  const me = _me.me;

  const { pathname } = useLocation();
  const { slug } = useParams();
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(null);
  const [membresia, setMembresia] = useState(null);
  const [reporte, setReporte] = useState(null);
  const [comission, setComission] = useState(15);
  /*{
    reportes: [],
    fechas: [
      {
        fechas: ["martes, 15 de octubre de 2024"],
        hora: "10:00",
        stock: "10",
      },
      {
        fechas: ["domingo, 20 de octubre de 2024"],
        hora: "21:00",
        stock: "10",
      },
    ],
    ficha_tecnica: {
      "En Escena": "Rodo Ramos",
      "Voz en Off": "Tomás Leaño",
      Dramaturgia: "Rodo Ramos",
      "Diseño de Iluminación": "Rodrigo Brunelli",
      "Diseño y Realización Escenográfica": "Rodo Ramos - Rodrigo Brunelli",
      "Diseño de Sonido": "Horacio Fierro",
      "Operación de Video": "Raquel Ambrosino",
      Vestuario: "Lucas Mana",
      "Fotografía y Diseño Gráfica": "Rodrigo Brunelli",
      Producción: "El Cuenco Teatro",
      Dirección: "Gastón Mori",
    },
    comisiones: {
      tasa: 15,
      id: 2,
      provincia: "Córdoba",
      status_id: 1,
    },
    entradas: [
      {
        id: 2,
        nombre: "General",
        tipo: "VENTA",
        precio: "800",
        habilitacion_fecha: "2024-10-01",
        eventos_id: 2,
        created_at: "2022-03-19T13:57:45.000000Z",
        updated_at: "2022-03-26T00:18:19.000000Z",
        stock: 0,
        status: "ACTIVO",
        habilitacion_hora: "10:00",
        multiplicador: null,
      },
      {
        id: 3,
        nombre: "Estudiantil",
        tipo: "VENTA",
        precio: "500",
        habilitacion_fecha: "2024-10-01",
        eventos_id: 2,
        created_at: "2022-03-19T13:57:45.000000Z",
        updated_at: "2022-03-26T00:18:19.000000Z",
        stock: 0,
        status: "ACTIVO",
        habilitacion_hora: "10:00",
        multiplicador: null,
      },
    ],
  }*/

  const [evento, setEvento] = useState(null);
  const [form, setForm] = useState({
    fecha: null,
    stock: 0,
  });

  const label = (step) => {
    switch (step) {
      case 0:
        {
          return (
            <label
              className={`btn btn-custom-naranja text-white fw-normal py-4 d-flex justify-content-center align-items-center fs-6 ${
                evento.entradas.filter((e) => e.quantity).length > 0
                  ? ""
                  : "disabled"
              }`}
              style={{ width: "160px", borderRadius: "10px" }}
            >
              Siguiente
              <i class="bi bi-chevron-right fs-6"></i>
              <button
                className="d-none"
                onClick={(e) => {
                  let int = step + 1;
                  console.log(int);

                  switch (int) {
                    case 1:
                      {
                        document.getElementById("nav-pagar-tab").click();
                        document
                          .getElementById("nav-pagar-tab-ofcanva")
                          .click();

                        /*
                        let entradas = {
                          select: form,
                          evento: evento,
                        };

                        localStorage.setItem(
                          "entradas",
                          JSON.stringify(entradas)
                        );
                        return (window.location.href = "/pagar");
                        */
                      }
                      break;
                    default:
                      break;
                  }
                  setStep(int);
                }}
              ></button>
            </label>
          );
        }
        break;
      case 1:
        {
          return (
            <div className="d-flex">
              <label
                className={`btn btn-custom-naranja d-flex justify-content-center align-items-center fs-6 text-white fw-normal py-2  me-2 ${
                  loading ? "disabled" : ""
                }`}
                style={{ width: "160px", borderRadius: "10px" }}
              >
                Pagar
                <i class="bi bi-chevron-right fs-6"></i>
                <button
                  className="d-none"
                  name={`${
                    TotalEntradaUtils(evento.entradas, comission).total > 0
                      ? "pagar"
                      : "gratis"
                  }`}
                  onClick={(e) => onClick(e)}
                ></button>
              </label>
            </div>
          );
        }
        break;
      default:
        break;
    }
  };

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "gratis":
        {
          const formdata = new FormData();
          formdata.append("nombre", me.nombre);
          formdata.append("email", me.email);
          formdata.append("telefono", me.telefono);
          formdata.append("id_evento", evento.id);
          formdata.append("fecha", form.fecha);
          formdata.append("hora", form.hora);
          evento.entradas.map((entrada, index) => {
            if (entrada.quantity ?? null) {
              formdata.append("entradas[" + index + "][id]", entrada.id);
              formdata.append(
                "entradas[" + index + "][quantity]",
                entrada.quantity
              );
            }
          });

          const result = await RestPrivateAntesala({
            url: "/checkout/free",
            formData: formdata,
            setLoading: setLoading,
            method: "POST",
          });

          if (result.status == 200) {
            setReporte({
              reporte: result.data.data,
            });
            return Alerts({
              msg: "Alert",
              title: "Entradas adquiridas",
              code: "401",
              type: "success",
            });
          }
        }
        break;
      case "pagar":
        {
          localStorage.removeItem("entradas");
          let entradas = {
            select: form,
            evento: evento,
            info: TotalEntradaUtils(evento.entradas, comission),
          };
          localStorage.setItem("entradas", JSON.stringify(entradas));
          return (window.location.href = "/checkout");
        }
        break;
      case "abonar-con-membresia":
        {
          setMembresia(value);

          const formdata = new FormData();
          formdata.append("nombre", me.nombre);
          formdata.append("email", me.email);
          formdata.append("telefono", me.telefono);
          formdata.append("id_evento", evento.id);
          formdata.append("membresia", value.code);
          formdata.append("fecha", form.fecha);
          formdata.append("hora", form.hora);
          evento.entradas.map((entrada, index) => {
            if (entrada.quantity ?? null) {
              formdata.append("entradas[" + index + "][id]", entrada.id);
              formdata.append(
                "entradas[" + index + "][quantity]",
                entrada.quantity
              );
            }
          });

          const response = await RestPrivateAntesala({
            url: "/checkout/paymembership",
            formData: formdata,
            setLoading: setLoading,
            method: "POST",
          });

          if (response.status == 201 || response.status == 200) {
            document.getElementById("modal-comprar-entradas").click();
            return Alerts({
              msg: "Alert",
              title: response.data?.msg,
              code: "401",
              type: "success",
            });
          } else {
            if (typeof response.data.msg == "string") {
              Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "warning",
              });
            } else {
              Object.keys(response.data.msg).map((key) => {
                return Alerts({
                  msg: "Alert",
                  title: response.data.msg[key][0],
                  code: "401",
                  type: "error",
                });
              });
            }
          }
        }
        break;
      case "add-date":
        {
          setForm({
            ...form,
            fecha: value.select,
            stock: value.stock,
            hora: value.hora,
          });
        }
        break;
      case "remove-date":
        {
          setForm({
            ...form,
            fecha: null,
            stock: 0,
          });
        }
        break;
      case "remove":
        {
          let set = evento.entradas;
          let quantity = set[value.index]?.quantity
            ? set[value.index].quantity - 1
            : 0;
          let stock = 0;
          if (set[value.index]["stock"] > 0) {
            stock = set[value.index]["stock"];
            evento.reportes.map((reporte) => {
              if (set[value.index]["id"] == reporte.entradas_id) {
                stock = stock - reporte.cantidad;
              }
            });
          } else {
            stock = form.stock;
            evento.reportes.map((reporte) => {
              if (
                set[value.index]["id"] == reporte.entradas_id &&
                reporte.fecha == form.fecha + " HORA: " + form.hora
              ) {
                stock = stock - reporte.cantidad;
              }
            });
          }

          if (stock == 0) {
            return "";
          }

          if (quantity != 0) {
            set[value.index]["quantity"] = quantity;
            set[value.index]["pricexquantity"] = quantity * value.precio;
            set[value.index]["remain"] = parseFloat(form.stock) - quantity;
            set[value.index]["serv"] =
              (set[value.index]["pricexquantity"] / 100) * comission;
            set[value.index]["remain"] = stock - set[value.index]["quantity"];

            return setEvento({
              ...evento,
              entradas: set,
            });
          } else {
            set[value.index]["quantity"] = 0;
            set[value.index]["pricexquantity"] = value.precio;
            set[value.index]["remain"] = stock;
            return setEvento({
              ...evento,
              entradas: set,
            });
          }
        }
        break;
      case "add":
        {
          let set = evento.entradas;
          let quantity = set[value.index]?.quantity
            ? set[value.index].quantity + 1
            : 1;
          let stock = 0;
          if (set[value.index]["stock"] > 0) {
            stock = set[value.index]["stock"];
            evento.reportes.map((reporte) => {
              if (set[value.index]["id"] == reporte.entradas_id) {
                stock = stock - reporte.cantidad;
              }
            });
          } else {
            stock = form.stock;
            evento.reportes.map((reporte) => {
              if (
                set[value.index]["id"] == reporte.entradas_id &&
                reporte.fecha == form.fecha + " HORA: " + form.hora
              ) {
                stock = stock - reporte.cantidad;
              }
            });
          }

          if (stock == 0) {
            return "";
          }

          set[value.index]["quantity"] = quantity;
          set[value.index]["pricexquantity"] = quantity * value.precio;
          set[value.index]["serv"] =
            (set[value.index]["pricexquantity"] / 100) * comission;
          set[value.index]["remain"] = stock - set[value.index]["quantity"];

          return setEvento({
            ...evento,
            entradas: set,
          });
        }
        break;
    }
  };

  const onChange = (e, value) => {
    switch (e.target.name) {
      case "":
        {
        }
        break;
    }
  };

  const fetch = async (setData, params, url) => {
    const response = await apiAntesala.get(url, { params });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (!evento) {
      fetch(setEvento, {}, `/eventos/${slug}`);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname])
  

  if (reporte) {
    return <Completado reporte={reporte} />;
  }

  return (
    <div className="container-fluid px-0 bg-light">
      <div className="w-100 shadow-sm mb-1 fixed-top bg-white">
        <Header discount={false} />
      </div>

      <div className="container-fluid min-vh-100">
        {evento ? (
          <Entrada
            setStep={setStep}
            step={step}
            entradas={evento?.entradas ?? []}
            onClick={onClick}
            comission={comission}
            form={form}
            evento={evento}
            label={label}
            me={me}
            membresia={membresia}
            loading={loading}
          />
        ) : null}
      </div>
      <div className="w-100 container-fluid px-0 mx-0">
        <Footer />
      </div>
    </div>
  );
};

export default EntradaController;
